import { buildProps } from '../../../utils/vue/props/runtime.mjs';

const tabPaneProps = buildProps({
  label: {
    type: String,
    default: ""
  },
  name: {
    type: [String, Number]
  },
  closable: {
    type: Boolean,
    default: void 0
  },
  disabled: Boolean,
  lazy: Boolean
});

export { tabPaneProps };
//# sourceMappingURL=tab-pane.mjs.map
